module.exports = __webpack_public_path__ + "img/timetwo.361ee100.png";